import { Injectable } from '@angular/core';
import { environment } from 'environments/environment.prod';
declare const swal: any;

@Injectable({
  providedIn: 'root'
})
export class VersionCheckService {
  private localStorageKey  = 'appVersion';

  constructor() { }

  checkVersion(): void {
    const currentVersion = environment.appVersion;
    const storedVersion = localStorage.getItem(this.localStorageKey);
     // If the stored version is different from the current version
     if (storedVersion !== currentVersion) {
      // Update the local storage with the current version
      localStorage.setItem(this.localStorageKey, currentVersion);
      // Force hard reload to clear the cache and load the new version
      window.location.reload();  // Forces a hard reload, bypassing the cache
    }
  }
}
